import { AfterViewChecked, Component, ElementRef, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ButtonComponent } from "../button/button.component";
import { TranslatePipe } from "../../data/pipes/translate.pipe";
import { SharedService } from '../../data/shared.service';
import { AuthService } from 'src/app/auth/data/auth.service';

@Component({
  selector: 'app-tos-dialog',
  imports: [CommonModule, ButtonComponent, TranslatePipe],
  templateUrl: './tos-dialog.component.html',
  styleUrl: './tos-dialog.component.scss',
})
export class TosDialogComponent implements AfterViewChecked {
  isLoading = false;
  disableAccept = false;
  disableReject = false;
  data = inject(DIALOG_DATA);
  dialogRef = inject(DialogRef);
  sharedService = inject(SharedService);
  authService = inject(AuthService);
  isRendered = false;

  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;

  ngAfterViewChecked(): void {
    if (!this.isRendered) {
      this.scrollContainer.nativeElement.scrollTop = 0;
      this.isRendered = true;
    }
  }

  async accept(): Promise<void> {
    this.isLoading = true;
    this.disableReject = true;

    await this.sharedService.acceptTermsOfService().then(() => {
      this.isLoading = false;
      this.dialogRef.close();
    });

  }

  async reject(): Promise<void> {
    this.isLoading = true;
    this.disableAccept = true;

    await this.sharedService.rejectTermsOfService().then(() => {
      this.isLoading = false;
      this.authService.logout();
      this.dialogRef.close();
    });
  }
}
